const loading = {

	elem: {
		body: document.querySelector('body'),
		// component: document.querySelector('.c26-loading'),
		inert: document.querySelectorAll('[inert]')
	},
	
	status: localStorage.getItem('return'),
	
	complete() {
		// localStorage.setItem('return', 'true');
		loading.elem.body.classList.remove('locked');
		// loading.elem.component.setAttribute('inert', true);
		loading.elem.inert.forEach(function(element) {
			element.removeAttribute('inert');
		});
	},		
	
	init() {
		// if (loading.status === null) {
		//	window.setTimeout( loading.complete, 5000);
		// } else {
		//	loading.complete();
		// }
		loading.complete();		
	}

};

export { loading };




